module.exports = __webpack_public_path__ + "img/baobiaochakan.7751858d.png";